/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ui/NG_RATING_FILLED': {
    width: 16,
    height: 16,
    viewBox: '0 0 17 17',
    data: '<path pid="0" _fill="#545454" fill-rule="evenodd" d="M8.5 14.1L3.25 17l1-6.15L0 6.49l5.87-.89L8.5 0l2.63 5.6 5.87.89-4.25 4.36 1 6.15-5.25-2.9z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/ui/NG_RATING_FILLED.js